import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import { lngsList } from "./config";
import tw from "./tw.json";
import en from "./en.json";
import zh_chs from "./zh_chs.json";
import viet from "./viet.json";
import id from "./id.json";
import jp from "./jp.json";
import th from "./th.json";

i18n.on("languageChanged", (lng) => {
  document.documentElement.setAttribute("lang", lng);
});

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    cleanCode: true,
    nonExplicitSupportedLngs: false,
    whitelist: lngsList,
    fallbackLng: process.env.REACT_APP_DEFAULT_LANGUAGE,
    supportedLngs: lngsList,
    detection: {
      order: ["path", "localStorage", "cookie", "htmlTag", "subdomain"],
      caches: [""],
      lookupFromPathIndex: 0,
      checkWhitelist: true,
      whitelist: lngsList,
    },
    resources: {
      tw: { translation: tw },
      en: { translation: en },
      cn: { translation: zh_chs },
      vi: { translation: viet },
      viet: { translation: viet },
      id: { translation: id },
      jp: { translation: jp },
      th: { translation: th },
    },
    debug: false,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
